import React from 'react';
import { Instagram, Youtube, Music, ArrowUpRight } from 'lucide-react';
import { SOCIAL_LINKS } from '../mock/mock';

const TikTokIcon = ({ className }) => (
  <svg className={className} viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
    <path d="M19.321 5.562a5.122 5.122 0 0 1-3.414-1.267 5.122 5.122 0 0 1-1.537-2.88h-3.273v13.218c0 1.524-1.242 2.762-2.762 2.762a2.762 2.762 0 0 1 0-5.524c.279 0 .547.042.8.118V8.634a6.034 6.034 0 0 0-.8-.054 6.04 6.04 0 1 0 6.04 6.04V9.314a8.394 8.394 0 0 0 4.946 1.593V7.634c0 0-.87-.018-2-.18V5.562z"/>
  </svg>
);

const AppleIcon = ({ className }) => (
  <svg className={className} viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
    <path d="M17.5 6.75a5.2 5.2 0 0 1-1.25-3.25c-.25-.25-.5-.5-.75-.5-.6 0-1.15.35-1.5.75-.35-.4-.9-.75-1.5-.75-1.1 0-2 .9-2 2 0 .75.4 1.4 1 1.75v11.25c0 .41-.34.75-.75.75s-.75-.34-.75-.75.34-.75.75-.75.75-.34.75-.75-.34-.75-.75-.75c-1.24 0-2.25 1.01-2.25 2.25s1.01 2.25 2.25 2.25 2.25-1.01 2.25-2.25V9.25c.67.18 1.5.25 2.25.25.5 0 1 0 1.5-.25.25 0 .5-.25.5-.5.25-.5.25-1.5.25-2z"/>
  </svg>
);

const LinkIcon = ({ className }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71"/>
    <path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71"/>
  </svg>
);

const SOCIALS = [
  { label: 'Instagram', href: SOCIAL_LINKS.instagram, Icon: Instagram },
  { label: 'Spotify', href: SOCIAL_LINKS.spotify, Icon: Music },
  { label: 'YouTube', href: SOCIAL_LINKS.youtube, Icon: Youtube },
  { label: 'TikTok', href: SOCIAL_LINKS.tiktok, Icon: TikTokIcon },
  { label: 'Apple Music', href: SOCIAL_LINKS.apple, Icon: AppleIcon },
  { label: 'Pre-Save', href: SOCIAL_LINKS.link, Icon: LinkIcon },
];

export default function Follow() {
  return (
    <section id="follow" className="py-9 md:py-11" style={{backgroundColor: '#7B96B5'}}>
      <div className="max-w-[1400px] mx-auto px-5 md:px-10">
        <div className="flex items-center justify-between flex-wrap gap-4 mb-6">
          <p className="font-anton uppercase tracking-[0.3em] text-brown text-[14.4px]">— Follow Mariah</p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-6 gap-2 md:gap-3">
          {SOCIALS.map((s) => (
            <a
              key={s.label}
              href={s.href}
              target="_blank"
              rel="noreferrer"
              className="group flex items-center justify-between border border-brown/60 hover:bg-brown text-brown hover:text-cream transition-colors duration-300 px-4 py-3 rounded-full"
            >
              <span className="inline-flex items-center gap-2">
                <s.Icon className="w-[19px] h-[19px]" />
                <span className="font-anton uppercase tracking-widest text-[13.2px]">{s.label}</span>
              </span>
              <ArrowUpRight className="w-[19px] h-[19px] opacity-60 group-hover:opacity-100 group-hover:-translate-y-0.5 group-hover:translate-x-0.5 transition-all" />
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}
